import { fetchBlogs } from "../../methods/fetch";

window.pageMixins = [
  {
    data() {
      return {
        relatedBlogs: [],
        categoryId: window.categoryId
      }
    },
    created() {
      fetchBlogs((relatedBlogs) => {
        this.relatedBlogs = relatedBlogs;
      }, 10, 1, { categoryId: this.categoryId });
    },
    methods: {
      mounted(heading) {
        this.tableOfContents = heading;
      }
    }
  }
];
